<template>
    <div>
        <h1>Hello Setting</h1>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>